import { Box, Typography } from "@mui/material";
import { AnimatePresence } from "motion/react";
import { CommentCard } from "../components/CommentCard";
import { commentKey, isAMatch } from "../core";
import { palette } from "../theme";
import type { CommentForContest } from "../generated/core-types";

interface ContestValidationProps {
  comments: CommentForContest[];
}

export function ContestValidation({ comments }: ContestValidationProps): JSX.Element {
  const total = comments.length;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5 }}>
        <Typography variant="h2" sx={{ m: 0 }}>
          {total === 0
            ? "Chưa có lượt tham gia"
            : total === 1
            ? "1 lượt tham gia"
            : `${total} lượt tham gia`}
        </Typography>
        <Typography variant="body2" sx={{ color: palette.inkSoft }}>
          kết quả khớp chính xác sẽ được làm nổi bật
        </Typography>
      </Box>
      {total === 0 ? (
        <Box
          sx={{
            py: { xs: 4, md: 6 },
            textAlign: "center",
            border: `1px dashed ${palette.border}`,
            borderRadius: 12,
            backgroundColor: palette.surface,
            color: palette.inkSoft,
          }}
        >
          <Typography variant="body2">
            Đang chờ người tham gia cuộc thi…
          </Typography>
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
          <AnimatePresence mode="popLayout" initial={false}>
            {comments.map((cfc) => (
              <CommentCard
                key={`${commentKey(cfc.comment)}_contest`}
                comment={cfc.comment}
                onValidate={() => {
                  /* No-op for contest cards — they're informational */
                }}
                highlightMatch={isAMatch(cfc)}
              />
            ))}
          </AnimatePresence>
        </Box>
      )}
    </Box>
  );
}
